import { DashboardComponent } from './ecare-parent/dashboard/dashboard.component';
import { DashboardResolve } from './ecare-parent/dashboard/dashboard.resolve';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth2-guard/auth.guard';
import { ErrorComponent } from './ecare-parent/error/error.component';
import { LiveDataComponent } from './ecare-parent/live-data/live-data.component';
import { LiveDataResolve } from './ecare-parent/live-data/live-data.resolve';
import {PackageViewComponent} from './ecare-parent/package/package-view/package-view.component';
import {EcareParentComponent} from './ecare-parent/ecare-parent.component';
import {Route, RouterModule, Routes} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';
import {ClientViewComponent} from './ecare-parent/client/client-view/client-view.component';
import {ClientinventoryViewComponent} from './ecare-parent/clientinventory/clientinventory-view/clientinventory-view/clientinventory-view.component';
import {PackageFormComponent} from './ecare-parent/package/package-form/package-form.component';
import {ClientFormComponent} from './ecare-parent/client/client-form/client-form.component';
import {PatientViewComponent} from './ecare-parent/patient/patient-view/patient-view.component';
import {PatientFormComponent} from './ecare-parent/patient/patient-form/patient-form.component';
import {OrderViewComponent} from './ecare-parent/order/order-view/order-view.component';
import {CampaignFormComponent} from './ecare-parent/campaign/campaign-form/campaign-form.component';
import {CampaignViewComponent} from './ecare-parent/campaign/campaign-view/campaign-view.component';
import {OrderFormComponent} from './ecare-parent/order/order-form/order-form.component';
import {ProvisionFormComponent} from './ecare-parent/order/provision-form/provision-form.component';
import {UserViewComponent} from './ecare-parent/user/user-view/user-view/user-view.component';
import {ClientteamViewComponent} from './ecare-parent/clientteam/clientteam-view/clientteam-view.component';
import {ClientteamFormComponent} from './ecare-parent/clientteam/clientteam-form/clientteam-form.component';
import {DeviceViewComponent} from './ecare-parent/device-view/device-view.component';
import {UserFormComponent} from './ecare-parent/user/user-form/user-form.component';
import {AuthenticationViewComponent} from './ecare-parent/authentication/authentication-view/authentication-view.component';
import {AuthenticationFormComponent} from './ecare-parent/authentication/authentication-form/authentication-form.component';
import {FirmwareViewComponent} from './ecare-parent/firmware/firmware-view/firmware-view/firmware-view.component';
import {FirmwareFormComponent} from './ecare-parent/firmware/firmware-form/firmware-form/firmware-form.component';
import {EventLogViewComponent} from './ecare-parent/eventlog/eventlog-view.component';
import {FilterViewComponent} from './ecare-parent/filters/filter-view/filter-view.component';
import {FilterFormComponent} from './ecare-parent/filters/filter-form/filter-form.component';
import {AlgorithmConfigViewComponent} from './ecare-parent/algorithm-config/algorithm-config-view/algorithm-config-view.component';
import {AlgorithmConfigFormComponent} from './ecare-parent/algorithm-config/algorithm-config-form/algorithm-config-form.component';
import {DataAvailabilityViewComponent} from './ecare-parent/data-availability/data-availability-view/dataavailability-view.component';
import {HistoryDataComponent} from './ecare-parent/history-data/history-data.component';
import {ReportViewComponent} from './ecare-parent/report/report-view/report-view.component';
import {ReportFormComponent} from './ecare-parent/report/report-form/report-form.component';
import {PhysicianViewComponent} from './ecare-parent/physician/physician-view/physician-view.component';
import {ViewTransactionComponent} from './ecare-parent/transaction/view-transaction/view-transaction.component';
import {AppointmentComponent} from './ecare-parent/appointment/appointment.component';
import {PhysicianDetailsComponent} from './ecare-parent/physician/physician-details/physician-details.component';
import {CommissionComponent} from './ecare-parent/physician/commission/commission.component';
import {UnpublishedCommentsComponent} from './ecare-parent/physician/physicisan-review-comments/unpublished-list/unpublished-comments.component';

export const AppRoutes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full'},
    { path: 'login' , component: LoginComponent },
    {path: 'elasticcare', component: EcareParentComponent,
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent,
                canActivate: [AuthGuard],
                resolve: {
                    consent: DashboardResolve
                },
                data: { title: 'Dashboard' }
            },
            {
                path: 'package',
                component: PackageViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Package' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'clientcontacts',
                component: ClientteamViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Client Contacts' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/clientcontact',
                component: ClientteamFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add Client Contact' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/packages',
                component: PackageFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add Package' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'clientinventory',
                component: ClientinventoryViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Client Inventory' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'client',
                component: ClientViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Client' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'user',
                component: UserViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'User' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/user',
                component: UserFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add User' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/client',
                component: ClientFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add Client' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/client/team',
                component: ClientteamFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add Client Team' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'order',
                component: OrderViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Order' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/order',
                component: OrderFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add Order' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'provision/order',
                component: ProvisionFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Provision Order' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'patient',
                component: PatientViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Patients' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'transaction',
                component: ViewTransactionComponent,
                canActivate: [AuthGuard],
                data: { title: 'Transactions' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'appointments',
                component: AppointmentComponent,
                canActivate: [AuthGuard],
                data: { title: 'Appointments' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },{
                path: 'commission',
                component: CommissionComponent,
                canActivate: [AuthGuard],
                data: { title: 'Commission' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },{
                path: 'comment',
                component: UnpublishedCommentsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Comment' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'physician',
                component: PhysicianViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Physicians' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'physician/physician-details',
                component: PhysicianDetailsComponent,
                canActivate: [AuthGuard],
                data: { title: 'Physicians Details' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/patient',
                component: PatientFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add Patient' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'campaign',
                component: CampaignViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'View Campaigns' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/campaign',
                component: CampaignFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add Campaign' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'report',
                component: ReportViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Report' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'create/report',
                component: ReportFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Create Report' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'authentications',
                component: AuthenticationViewComponent,
                canActivate: [AuthGuard],
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/authentications',
                component: AuthenticationFormComponent,
                canActivate: [AuthGuard],
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'firmware',
                component: FirmwareViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Firmware Setup' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/firmware',
                component: FirmwareFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add Firmware' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'filter',
                component: FilterViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Filter' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/filter',
                component: FilterFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add Filter' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'algorithm',
                component: AlgorithmConfigViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Algorithm' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },
            {
                path: 'add/algorithm',
                component: AlgorithmConfigFormComponent,
                canActivate: [AuthGuard],
                data: { title: 'Add Algorithm' }
                /*resolve: {
                      consent: DashboardResolve
                  },*/
            },

            /*
                {
                  path: 'login',
                  component: LoginComponent
                },
            */

            {
                path: 'error',
                component: ErrorComponent
            },
            {
                path: 'live-data',
                component: LiveDataComponent,
                canActivate: [AuthGuard],
                data: { title: 'Live Data' },
                resolve: {
                    livedata: LiveDataResolve
                },
            },
            {
                path: 'history-data',
                component: HistoryDataComponent,
                canActivate: [AuthGuard],
                data: { title: 'History Data' }
            },
            {
                path: 'device-view',
                component: DeviceViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Devices' }
            },
            {
                path: 'eventlog-view',
                component: EventLogViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Event Logs' }
            }
            ,
            {
                path: 'availabledata-view',
                component: DataAvailabilityViewComponent,
                canActivate: [AuthGuard],
                data: { title: 'Data Availability' }
            }
        ]
    }
];
export const appRoutingProviders: any[] = [
];

export const routing: ModuleWithProviders = RouterModule.forRoot(AppRoutes, { useHash: true });
